import { useDrag } from '../../gestures/drag/use-drag.js';
import { usePanGesture } from '../../gestures/use-pan-gesture.js';
import { makeRenderlessComponent } from '../utils/make-renderless-component.js';

var drag = {
    pan: makeRenderlessComponent(usePanGesture),
    drag: makeRenderlessComponent(useDrag),
};

export { drag };
